import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { storeActivityIndicator, storeImageViewer, storeSelectedCompany } from "../../../redux/reducers/authSlice";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { GetCompanyListResponse, GetCompanyListResponseItem } from "../../../models/response/company/GetCompanyListResponse";
import { CompanyService } from "../../../services/CompanyService";
import { AddDriverRequest } from "../../../models/request/driver/AddDriverRequest";
import { DriverService } from "../../../services/DriverService";
import { AddDriverResponse } from "../../../models/response/driver/AddDriverResponse";
import { GetDriverByIdResponse, GetDriverByIdResponseFileArchive, GetDriverByIdResponsePeriodicalDocument } from "../../../models/response/driver/GetDriverByIdResponse";
import { useMask } from "@react-input/mask";
import GeneralInformation from "./Components/GeneralInformation";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { ConstantService } from "../../../services/ConstantService";
import { AddConstantResponse } from "../../../models/response/constant/AddConstantResponse";
import CustomMultiSelect, { CustomMultiSelectModel } from "../../../components/CustomMultiSelect";
import LicenceInformation from "./Components/LicenceInformation";
import IdentityInformation from "./Components/IdentityInformation";
import PeriodicalDocuments from "./Components/PeriodicalDocuments";
import FileArchives from "./Components/FileArchives";

const DriverAdd = () => {
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Sürücü Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const generalInformationRef: any = useRef();
    const licenceInformationRef: any = useRef();
    const identityInformationRef: any = useRef();
    const periodicalDocumentsRef: any = useRef();
    const fileArchivesRef: any = useRef();

    const [driverId, setDriverId] = useState<string | undefined>(undefined);

    // GENEL BİLGİLER
    const driverFileRef: any = useRef();
    const [driverFileB64, setDriverFileB64] = useState(Helpers.getPlaceholder());
    const [driverFile, setDriverFile] = useState<File | undefined>(undefined);
    const [tckn, setTckn] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [surname, setSurname] = useState<string | undefined>(undefined);
    const [selectedRelatedCompany, setSelectedRelatedCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const phone1Ref = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });
    const [phone1, setPhone1] = useState<string | undefined>(undefined);
    const phone2Ref = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });
    const [phone2, setPhone2] = useState<string | undefined>(undefined);
    const [email, setEmail] = useState<string | undefined>(undefined);
    const [workStartDate, setWorkStartDate] = useState<string | undefined>(undefined);
    const [workEndDate, setWorkEndDate] = useState<string | undefined>(undefined);
    const [address, setAddress] = useState<string | undefined>(undefined);
    const [desc, setDesc] = useState<string | undefined>(undefined);
    const [RFID, setRFID] = useState<string | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState(true);

    // EHLİYET BİLGİLERİ
    const [licenceSerialNumber, setLicenceSerialNumber] = useState<string | undefined>(undefined);
    const [licenceDigitalNumber, setLicenceDigitalNumber] = useState<string | undefined>(undefined);
    const [selectedLicenceClass, setSelectedLicenceClass] = useState<CustomMultiSelectModel[]>([]);
    const [driverRecordNo, setDriverRecordNo] = useState<string | undefined>(undefined);
    const [selectedBloodType, setSelectedBloodType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [dateOfBirth, setDateOfBirth] = useState<string | undefined>(undefined);
    const [givenDate, setGivenDate] = useState<string | undefined>(undefined);
    const [validityDate, setValidityDate] = useState<string | undefined>(undefined);
    const [givenPlace, setGivenPlace] = useState<string | undefined>(undefined);
    const licenceFileRef: any = useRef();
    const [licenceFileB64, setLicenceFileB64] = useState(Helpers.getPlaceholder());
    const [licenceFile, setLicenceFile] = useState<File | undefined>(undefined);
    const [placeOfBirth, setPlaceOfBirth] = useState<string | undefined>(undefined);

    // KİMLİK BİLGİLERİ
    const [identitySerialNumber, setIdentitySerialNumber] = useState<string | undefined>(undefined);
    const [selectedCitizenship, setSelectedCitizenship] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCitizenshipCountry, setSelectedCitizenshipCountry] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [identityValidityDate, setIdentityValidityDate] = useState<string | undefined>(undefined);
    const [age, setAge] = useState<string | undefined>(undefined);
    const [selectedGender, setSelectedGender] = useState<CustomSingleSelectModel | undefined>(undefined);
    const identityFileRef: any = useRef();
    const [identityFileB64, setIdentityFileB64] = useState(Helpers.getPlaceholder());
    const [identityFile, setIdentityFile] = useState<File | undefined>(undefined);

    // SÜRELİ BELGELER
    const [periodicalDocuments, setPeriodicalDocuments] = useState<GetDriverByIdResponsePeriodicalDocument[]>([]);

    // DOSYA ARŞİV
    const [fileArchives, setFileArchives] = useState<GetDriverByIdResponseFileArchive[]>([]);

    const handleFileRead = async (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => {
        try {
            const file = event.target.files[0]
            const base64: any = await convertBase64(file)
            setFunction(base64);
        } catch (error) {
            setFunction(Helpers.getPlaceholder())
        }
    }

    const convertBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetDriverByIdResponse = await DriverService.getDriverById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setDriverId(response.data.driverId);
                setTckn(response.data.tckn);
                setName(response.data.name);
                setSurname(response.data.surname);

                if (response.data.relatedCompanyId)
                    setSelectedRelatedCompany({ label: response.data.relatedCompanyName, value: response.data.relatedCompanyId })

                setPhone1(response.data.phone1);
                setPhone2(response.data.phone2);
                setEmail(response.data.email);
                setIsCustomActive(response.data.isCustomActive);
                setWorkStartDate(response.data.workStartDate);
                setWorkEndDate(response.data.workEndDate);
                setAddress(response.data.address);
                setDesc(response.data.description);
                setRFID(response.data.rfid);
                setDriverFileB64(Helpers.isEmpty(response.data.driverImage) ? Helpers.getPlaceholder() : response.data.driverImage)
                setIdentityFileB64(Helpers.isEmpty(response.data.identityImage) ? Helpers.getPlaceholder() : response.data.identityImage)
                setLicenceSerialNumber(response.data.licenceSerialNumber);
                setLicenceDigitalNumber(response.data.licenceDigitalNumber);

                if (response.data.driverClasses)
                    setSelectedLicenceClass(response.data.driverClasses);

                setDriverRecordNo(response.data.driverRecordNo);

                if (response.data.bloodTypeId)
                    setSelectedBloodType({ label: response.data.bloodTypeName, value: response.data.bloodTypeId });

                setDateOfBirth(response.data.dateOfBirth);
                setPlaceOfBirth(response.data.placeOfBirth);
                setGivenDate(response.data.givenDate);
                setValidityDate(response.data.validityDate);
                setGivenPlace(response.data.givenPlace);
                setLicenceFileB64(Helpers.isEmpty(response.data.licenceImage) ? Helpers.getPlaceholder() : response.data.licenceImage);

                setIdentitySerialNumber(response.data.identitySerialNumber);

                if (response.data.citizenshipId)
                    setSelectedCitizenship({ label: response.data.citizenshipName, value: response.data.citizenshipId, additionalValue1: response.data.citizenshipKey });

                if (response.data.citizenshipCountryId)
                    setSelectedCitizenshipCountry({ label: response.data.citizenshipCountryName, value: response.data.citizenshipCountryId });

                setIdentityValidityDate(response.data.identityValidityDate);
                setAge(response.data.age?.toString());

                if (response.data.genderId)
                    setSelectedGender({ label: response.data.genderName, value: response.data.genderId });

                setPeriodicalDocuments(response.data.periodicalDocuments);

                setFileArchives(response.data.fileArchives);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveDriver = async () => {
        try {
            if (selectedCitizenship?.additionalValue1 == 'TC' && Helpers.isEmpty(tckn))
                toast.error('TC Kimlik No alanını doldurunuz!')
            else if (Helpers.isEmpty(name))
                toast.error('Adı alanını doldurunuz!')
            else if (Helpers.isEmpty(surname))
                toast.error('Soyadı alanını doldurunuz!')
            else if (Helpers.isEmpty(selectedRelatedCompany))
                toast.error('Bağlı Olduğu Firma alanını doldurunuz!')
            else if (Helpers.isEmpty(phone1))
                toast.error('Telefon 1 alanını doldurunuz!')
            else if ((!Helpers.isEmpty(phone1) && phone1 && phone1.length < 15) || (!Helpers.isEmpty(phone2) && phone2 && phone2.length < 15))
                toast.error('Lütfen geçerli bir telefon numarası giriniz!')
            else if (!Helpers.isEmpty(email) && email && !Helpers.validateEmail(email))
                toast.error('Lütfen geçerli bir email adresi giriniz!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddDriverRequest = {
                    driverId: driverId,
                    address: address,
                    description: desc,
                    rfid: RFID,
                    driverImage: driverFile,
                    driverImageUrl: (driverFileB64.startsWith("http") ? driverFileB64 : undefined),
                    identityImage: identityFile,
                    identityImageUrl: (identityFileB64.startsWith("http") ? identityFileB64 : undefined),
                    email: email,
                    isCustomActive: isCustomActive ? 1 : 0,
                    name: name,
                    phone1: phone1,
                    phone2: phone2,
                    relatedCompanyId: selectedRelatedCompany?.value,
                    surname: surname,
                    tckn: tckn,
                    workEndDate: workEndDate,
                    workStartDate: workStartDate,
                    bloodTypeId: selectedBloodType?.value,
                    dateOfBirth: dateOfBirth,
                    placeOfBirth: placeOfBirth,
                    driverClassIds: selectedLicenceClass.map(x => x.value).join(","),
                    driverRecordNo: driverRecordNo,
                    givenDate: givenDate,
                    givenPlace: givenPlace,
                    licenceImage: licenceFile,
                    licenceImageUrl: (licenceFileB64.startsWith("http") ? licenceFileB64 : undefined),
                    licenceSerialNumber: licenceSerialNumber,
                    licenceDigitalNumber: licenceDigitalNumber,
                    validityDate: validityDate,
                    age: age,
                    citizenshipId: selectedCitizenship?.value,
                    citizenshipCountryId: selectedCitizenshipCountry?.value,
                    genderId: selectedGender?.value,
                    identitySerialNumber: identitySerialNumber,
                    identityValidityDate: identityValidityDate,
                    periodicalDocuments: periodicalDocuments.map(function (x) {
                        return {
                            additionalValue1: x.additionalValue1,
                            dateControl: x.dateControl ? 1 : 0,
                            documentNo: x.documentNo,
                            documentTypeId: x.documentTypeId,
                            endDate: x.endDate,
                            additionalValue2: x.additionalValue2
                        }
                    }),
                    fileArchives: fileArchives.map(function (x) {
                        return {
                            description: x.description,
                            entityId: x.entityId,
                            file: x.fileArchiveFile,
                            fileName: x.fileName,
                            fileTypeId: x.fileTypeId,
                            fileArchiveId: x.fileArchiveId
                        }
                    })
                }

                var response: AddDriverResponse = await DriverService.addDriver(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Ehliyet Bilgileri', ref: licenceInformationRef },
                            { text: 'Kimlik Bilgileri', ref: identityInformationRef },
                            { text: 'Süreli Belgeler', ref: periodicalDocumentsRef },
                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                        ]}
                    />

                    <GeneralInformation
                        address={address}
                        desc={desc}
                        RFID={RFID}
                        driverFileB64={driverFileB64}
                        driverFileRef={driverFileRef}
                        email={email}
                        generalInformationRef={generalInformationRef}
                        handleFileRead={handleFileRead}
                        isCustomActive={isCustomActive}
                        name={name}
                        phone1={phone1}
                        phone1Ref={phone1Ref}
                        phone2={phone2}
                        phone2Ref={phone2Ref}
                        selectedRelatedCompany={selectedRelatedCompany}
                        setAddress={setAddress}
                        setDesc={setDesc}
                        setRFID={setRFID}
                        setDriverFile={setDriverFile}
                        setDriverFileB64={setDriverFileB64}
                        setEmail={setEmail}
                        setIsCustomActive={setIsCustomActive}
                        setName={setName}
                        setPhone1={setPhone1}
                        setPhone2={setPhone2}
                        setSelectedRelatedCompany={setSelectedRelatedCompany}
                        setSurname={setSurname}
                        setWorkEndDate={setWorkEndDate}
                        setWorkStartDate={setWorkStartDate}
                        surname={surname}
                        workEndDate={workEndDate}
                        workStartDate={workStartDate}
                        dateOfBirth={dateOfBirth}
                        setDateOfBirth={setDateOfBirth}
                        placeOfBirth={placeOfBirth}
                        setPlaceOfBirth={setPlaceOfBirth}
                    />

                    <LicenceInformation
                        driverRecordNo={driverRecordNo}
                        givenDate={givenDate}
                        givenPlace={givenPlace}
                        handleFileRead={handleFileRead}
                        licenceFileB64={licenceFileB64}
                        licenceFileRef={licenceFileRef}
                        licenceInformationRef={licenceInformationRef}
                        licenceSerialNumber={licenceSerialNumber}
                        licenceDigitalNumber={licenceDigitalNumber}
                        selectedBloodType={selectedBloodType}
                        selectedLicenceClass={selectedLicenceClass}
                        setDriverRecordNo={setDriverRecordNo}
                        setGivenDate={setGivenDate}
                        setGivenPlace={setGivenPlace}
                        setLicenceFile={setLicenceFile}
                        setLicenceFileB64={setLicenceFileB64}
                        setLicenceSerialNumber={setLicenceSerialNumber}
                        setLicenceDigitalNumber={setLicenceDigitalNumber}
                        setSelectedBloodType={setSelectedBloodType}
                        setSelectedLicenceClass={setSelectedLicenceClass}
                        setValidityDate={setValidityDate}
                        validityDate={validityDate}
                    />

                    <IdentityInformation
                        age={age}
                        identityInformationRef={identityInformationRef}
                        identitySerialNumber={identitySerialNumber}
                        identityValidityDate={identityValidityDate}
                        selectedCitizenship={selectedCitizenship}
                        selectedGender={selectedGender}
                        setAge={setAge}
                        setIdentitySerialNumber={setIdentitySerialNumber}
                        setIdentityValidityDate={setIdentityValidityDate}
                        setSelectedCitizenship={setSelectedCitizenship}
                        setSelectedGender={setSelectedGender}
                        setTckn={setTckn}
                        tckn={tckn}
                        identityFileB64={identityFileB64}
                        identityFileRef={identityFileRef}
                        setIdentityFile={setIdentityFile}
                        setIdentityFileB64={setIdentityFileB64}
                        handleFileRead={handleFileRead}
                        selectedCitizenshipCountry={selectedCitizenshipCountry}
                        setSelectedCitizenshipCountry={setSelectedCitizenshipCountry}
                    />

                    <PeriodicalDocuments
                        periodicalDocuments={periodicalDocuments}
                        periodicalDocumentsRef={periodicalDocumentsRef}
                        setPeriodicalDocuments={setPeriodicalDocuments}
                    />

                    <FileArchives
                        fileArchives={fileArchives}
                        fileArchivesRef={fileArchivesRef}
                        setFileArchives={setFileArchives}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveDriver}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default DriverAdd;